import React, { useEffect, useState, useRef } from "react";
import { connect, useDispatch } from 'react-redux';
import { Col, Input, Row } from 'reactstrap';
import { translate } from "../../../utils/translate";
import "../../../css/team.scss";
import "../../../css/tree2.scss"
import { api } from "../../../utils/api";
import { digitFormat } from "../../../utils/function";
import { logout } from "../../../store/actions/AuthActions";
import Loadingv3 from "../../components/Loading/LoadingV3.js";
import swal from "sweetalert";
import { Modal } from "react-bootstrap";

const TeamInvestment = (props) => {
  const dispatch = useDispatch();
  const [parent, setParent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingModal, setLoadingModal] = useState(false);
  const treeRef = useRef(null);
  const [teamData, setTeamData] = useState([]);
  const [checkedItem, setCheckedItem] = useState([]);
  const [infoModal, setInfoModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const showUnlimitedUserList = [''];

  useEffect(() => {
    getTreeData();
  }, [props.lang])

  const getTreeData = () => {
    setLoading(true);
    fetch(api.team_detail + `/${0}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept-Language": props.lang.toLowerCase(),
        "Authorization": "Bearer " + props.auth.auth.access_token
      }),
    })
      .then(response => response.json())
      .then(responseJson => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        if (responseJson.status === 'success') {
          let tempTree = [{ ...responseJson.data.self_results, children: responseJson.data.downline_results }]
          setCheckedItem([responseJson.data.self_results.customer_id]);
          setParent([responseJson.data.self_results])
          setTeamData(tempTree)
        } else {
          if (responseJson.status === 'error' && responseJson.message === 'Token Expired') {
            dispatch(logout(props.history, 'login'));
          }
        }
      }).catch(error => {
        console.error("error", error);
      });
  }

  const getChildren = (member, level) => {
    fetch(api.team_detail + `/${member.customer_id}`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        "Accept-Language": props.lang.toLowerCase(),
        "Authorization": "Bearer " + props.auth.auth.access_token
      }),
    })
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.status === 'success') {
          if (responseJson.data.downline_results.length > 0) {
            findArrayByUsername(teamData, responseJson.data.downline_results, member.customer_id)
          }
        } else {
          swal(translate(props.lang, "Error"), responseJson.message, "error");
        }
      }).catch(error => {
        console.error("error", error);
      });
  }

  const findArrayByUsername = (mainArr, newArr, uid) => {
    let newGroupMember = findById(mainArr, newArr, uid);
    console.log('newGroupMember', newGroupMember)
    setParent([...newGroupMember]);
  }

  function findById(array, newArray, id) {
    for (let i = 0; i < array.length; i++) {
      if (array[i].customer_id === id) {
        if (array[i].children) {
          if (array[i].children.length !== newArray.length) {
            array[i].children = newArray;
            break;
          } else {
            break;
          }
        } else {
          array[i].children = newArray;
          break;
        }

      } else {
        if (array[i].children && array[i].children.length > 0) {
          findById(array[i].children, newArray, id);
        }
      }
    }
    return array;
  }

  const showInfo = (data) => {
    setSelectedUser(data);
    setInfoModal(true);
  }

  const renderSingleView = (item, level) => {
    return (
      <div className="border-tree-column mt-2 w-100">
        <div className="checkbox-area" onClick={() => onChangeCheckbox(item, level)}></div>
        <div className="d-flex justify-content-start align-items-stretch mx-0 h-100 mx-0 px-0 py-2 py-md-3 w-100">
          <div lg={4} md={4} xs={3} sm={3} className="px-2 first-column">
            <div className="d-flex align-items-center w-100">
              <div className="px-md-3 ps-3 pe-1" onClick={() => showInfo(item)}>
                <img src={require('../../../images/team/info.svg').default} className="img-fluid rank-info" alt="info" />
              </div>
              <div className="text-center w-100" onClick={() => onChangeCheckbox(item, level)}>
                <div className="">
                  <span className="font-20 font-weight-600 text-black break-all-word break-white-space">{item.full_name ? item.full_name : item.nick_name ? item.nick_name : '-'}</span>
                </div>
                <div className="mt-2">
                  <span className="font-13 line-height-18 text-grey-1 overflow-wrap-anywhere break-white-space">{translate(props.lang, "Wallet Balance")} : {item.wallet_balance ? Number(item.wallet_balance).toLocaleString('en-US', digitFormat) : 0}</span>
                </div>
              </div>
            </div>
          </div>
          <div lg={8} md={8} xs={9} sm={9} className="px-2 second-column" onClick={() => onChangeCheckbox(item, level)}>
            <div className="d-flex align-items-center justify-content-start justify-content-lg-between w-100 h-100">
              <div className="text-center px-2 investment-column">
                <div>
                  <span className="font-20 font-weight-600 text-black break-all-word overflow-wrap-anywhere break-white-space">{item.total_member.toLocaleString('en-US')}</span>
                </div>
                <div className="mt-2 text-overflow-ellipsis">
                  <span className="font-weight-400 font-16 text-capitalize text-grey-1 break-all-word overflow-wrap-anywhere break-white-space">{translate(props.lang, "Total Member")}</span>
                </div>
              </div>
              <div className="text-center px-2 investment-column">
                <div>
                  <span className="font-20 font-weight-600 text-black break-all-word overflow-wrap-anywhere break-white-space">{item.total_active_member ? item.total_active_member.toLocaleString('en-US') : 0}</span>
                </div>
                <div className="mt-2 text-overflow-ellipsis">
                  <span className="font-weight-400 font-16 text-capitalize text-grey-1 break-all-word overflow-wrap-anywhere break-white-space">{translate(props.lang, "Total Active Member")}</span>
                </div>
              </div>
              <div className="text-center px-2 investment-column">
                <div>
                  <span className="font-20 font-weight-600 text-black break-all-word overflow-wrap-anywhere break-white-space">{item.total_sales ? Number(item.total_sales).toLocaleString('en-US', digitFormat) : 0}</span>
                </div>
                <div className="mt-2 text-overflow-ellipsis">
                  <span className="font-weight-400 font-16 text-capitalize text-grey-1 break-all-word overflow-wrap-anywhere break-white-space">{translate(props.lang, "Total Sales")}</span>
                </div>
              </div>
              <div className="text-center px-2 investment-column">
                <div>
                  <span className="font-20 font-weight-600 text-black break-all-word overflow-wrap-anywhere break-white-space">{item.personal_deposit ? Number(item.personal_deposit).toLocaleString('en-US', digitFormat) : 0}</span>
                </div>

                <div className="mt-2 text-overflow-ellipsis">
                  <span className="font-weight-400 font-16 text-capitalize text-grey-1 break-all-word overflow-wrap-anywhere break-white-space">{translate(props.lang, "MT5 Balance")}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderChildNode = (item, level) => {
    let checkLevel1 = true; 
    let checkLevel2 = true; 
    if (level < 2) {
      checkLevel1 = true;
    }
    if (showUnlimitedUserList.includes(props.auth.auth.customer_id)) {
      checkLevel2 = true;
      checkLevel1 = true
    } else {
      if (level < 3) {
        checkLevel2 = true;
      }
    }

    if (item.is_have_downline > 0 && checkLevel2) {
      if (item.children && item.children.length > 0) {
        return (
          <ul className="pure-tree">
            {item.children.map((child, i) => (
              <li key={i} className={`child-node ${child.is_have_downline > 0 && checkLevel2 ? 'has-children' : ''}`}>
                {child.is_have_downline > 0 && checkLevel1 ? (
                  <Input type="checkbox" className="noBorder" id={child.customer_id} value={child.customer_id} checked={checkedItem.includes(child.customer_id)} onChange={() => onChangeCheckbox(child, level)} />
                ) : null}
                <div className="single-view">
                  {renderSingleView(child, level)}
                </div>

                {checkedItem.includes(child.customer_id) ? renderChildNode(child, level + 1) : null}
              </li>
            ))}
          </ul>
        )
      } else {
        return null
      }
    } else {
      return null
    }
  }

  const onChangeCheckbox = (member, level) => {
    let formatItem = member;
    let arr = checkedItem;
    let checkLevel2 = true; 
    if (showUnlimitedUserList.includes(props.auth.auth.customer_id)) {
      checkLevel2 = true;
    } else {
      if (level < 3) {
        checkLevel2 = true;
      }
    }
    if (formatItem.is_have_downline > 0 && checkLevel2) {
      if (arr.includes(formatItem.customer_id)) {
        let newArr = arr.filter(item => item !== formatItem.customer_id)
        setCheckedItem(newArr);
      } else {
        getChildren(formatItem, level);
        setCheckedItem(arr.concat(formatItem.customer_id));
      }
    }
  }

  const closeInfoModal = () => {
    setSelectedUser(null);
    setInfoModal(false);
  }

  return (
    <>
      <div className="teaminvestment pb-5 px-1 px-lg-0 ms-2" id="tree">
        {loading ? (
          <Loadingv3 theme="dark" />
        ) : (
          teamData.length > 0 ? (
            <ul id="compositions-list" className="pure-tree main-tree mt-3" ref={treeRef} >
              <li>
                {teamData[0].children && teamData[0].children.length > 0 ? (
                  <Input type="checkbox" className="noBorder" id={teamData[0].customer_id} value={teamData[0].customer_id} checked={checkedItem.includes(teamData[0].customer_id)} onClick={() => onChangeCheckbox(teamData[0], 0)} />
                ) : null}
                <div className="single-view">
                  {renderSingleView(teamData[0], 0)}
                </div>
                {checkedItem.includes(teamData[0].customer_id) ? renderChildNode(teamData[0], 0) : null}
              </li>
            </ul>
          ) : null
        )}
      </div>
      <Modal className="fade bgImgModal" show={infoModal} centered>
        <Modal.Header className="border-0 pt-4 pb-2">
          <div className="d-flex w-100 align-items-center">
            <div className="w-75"></div>
            <div className="w-25 text-end cursor-pointer" onClick={() => closeInfoModal()} >
              <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
              </svg>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body className="border-0 px-3">
          <div className='bgWhite h-100'>
            <div className="px-0 px-md-4 h-100">
              <Row className="justify-content-start px-0 mx-0">
                <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                  <div className="text-center">
                    <span className="font-weight-600 font-30 text-black">{translate(props.lang, "Member Details")}</span>
                  </div>
                </Col>
                <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                  <Row className="justify-content-center justify-content-md-start px-0 mx-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-0">
                      <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Email")}</span>
                      <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{selectedUser && selectedUser.email ? selectedUser.email : '-'}</span>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                      <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Name")}</span>
                      <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{selectedUser ? selectedUser.full_name ? selectedUser.full_name : selectedUser.nick_name : '-'}</span>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12} className="mt-3 mt-md-4">
                      <span className={`font-weight-400 font-18 text-grey-9 d-block`}>{translate(props.lang, "Rank")}</span>
                      <span className={`font-weight-600 font-18 text-black d-block mt-2`}>{selectedUser && selectedUser.rank_detail ? selectedUser.rank_detail.rank_name : '-'}</span>
                    </Col>
                  </Row>
                </Col>

              </Row>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const mapStateToProps = (state) => {
  const { auth, i18n } = state;
  return {
    lang: i18n.lang,
    auth: auth,
  }
};

export default connect(mapStateToProps)(TeamInvestment);
